import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<circle cx="12" cy="12" r="10" fill="#C1D0CB"/> <path fill-rule="evenodd" clip-rule="evenodd" d="m7.58 10.986 3.978-3.978a.625.625 0 0 1 .884 0l3.977 3.978a.625.625 0 1 1-.883.884l-2.91-2.911v7.685a.625.625 0 0 1-1.25 0V8.959l-2.911 2.91a.625.625 0 0 1-.884-.883Z" fill="#193446"/>' }
  })
);